module.exports = __webpack_public_path__ + "img/partnership_04.7524f4d5.jpg";